import React from 'react'

import { useDeleteTimeEntryConfirmationStore } from '@/stores/useDeleteTimeEntryConfirmationStore'
import { PermanentDeleteDialog } from './PermanentDeleteDialog'

/** The shared time entry deletion confirmation (MIRA-4295). */
export function TimeEntryDeleteConfirmationDialog() {
  const request = useDeleteTimeEntryConfirmationStore(state => state.request)
  const deleting = useDeleteTimeEntryConfirmationStore(state => state.deleting)
  const cancel = useDeleteTimeEntryConfirmationStore(state => state.cancel)
  const confirm = useDeleteTimeEntryConfirmationStore(state => state.confirm)

  if (!request) return null

  return (
    <PermanentDeleteDialog
      count={request.count}
      entity={request.entity || 'time entry'}
      loading={deleting}
      workItemCountInEntry={request.workItemCountInEntry}
      onClose={cancel}
      onConfirm={confirm}
    />
  )
}
